import * as React from 'react';
import { Component } from 'react';
import { observer } from 'mobx-react';
import styled, { withTheme } from 'styled-components';
import { propStyles } from '@kurtosys/ksys-portal-components/build/utils/propStyles';
import FundFactItem from './FundFactItem';
import Translate from './Translate';
import Disclaimers from './Disclaimers';

const FundFactsWrapper = styled<any, any>('div')`
    ${propStyles};
`;

FundFactsWrapper.defaultProps = {};

const FundFactsHeading = styled<any, any>('h2')`
    ${propStyles};
`;

FundFactsHeading.defaultProps = {
    color: 'body',
    fontFamily: 'heading',
    fontWeight: 'bold',
    fontSize: 'md',
};

const FundFactsList = styled<any, any>('ul')`
    ${propStyles};
    list-style: none;
`;

FundFactsList.defaultProps = {
    display: 'flex',
    flexWrap: 'wrap',
    marginY: 'md',
};

@observer
class FundFacts extends Component<any, any> {
    render() {
        const {
            dataStore,
            theme,
            showHeading,
            fundFacts,
            cards,
            rows,
            disclaimers,
            cardDisclaimers,
        } = this.props;
        const { multipleValueLayout = 'column' } = fundFacts;
        return (
            <FundFactsWrapper {...theme.FundFactsWrapper}>
                {showHeading && (
                    <FundFactsHeading {...theme.FundFactsHeading}>
                        <Translate>{fundFacts.label}</Translate>
                    </FundFactsHeading>
                )}
                <FundFactsList {...theme.FundFactCardsList}>
                    {cards.map((card, index) => (
                        <FundFactItem
                            dataStore={dataStore}
                            key={`${card.label}-${index}`}
                            card={card}
                            theme={{
                                ...theme,
                                FundFactItem: theme.FundFactCardListItem,
                                FundFact: theme.FundFactCard,
                                FundFactHeading: theme.FundFactCardHeading,
                                FundFactAsAtDate: theme.FundFactCardAsAtDate,
                                FundFactValue: theme.FundFactCardValue,
                            }}
                            multipleValueLayout={multipleValueLayout}
                        />
                    ))}
                </FundFactsList>
                <FundFactsList {...theme.FundFactRowsList}>
                    {rows.map((card, index) => (
                        <FundFactItem
                            dataStore={dataStore}
                            key={`${card.label}-${index}`}
                            card={card}
                            theme={{
                                ...theme,
                                FundFactItem: {
                                    flex: ['1 0 100%', '0 1 50%'],
                                    minHeight: '0',
                                    ...theme.FundFactRowListItem,
                                },
                                FundFact: {
                                    flexDirection: 'row',
                                    boxShadow: 'none',
                                    borderStyle: 'none none solid none',
                                    borderRadius: '0',
                                    padding: 'sm',
                                    ...theme.FundFactRow,
                                },
                                FundFactHeading: {
                                    fontSize: 'sm',
                                    flex: '1 1 auto',
                                    textAlign: 'left',
                                    margin: '0',
                                    ...theme.FundFactRowHeading,
                                },
                                FundFactAsAtDate: theme.FundFactRowAsAtDate,
                                FundFactValue: {
                                    flex: '1 1 50%',
                                    fontSize: 'sm',
                                    color: 'body',
                                    textAlign: 'right',
                                    justifyContent: 'flex-end',
                                    ...theme.FundFactRowValue,
                                },
                            }}
                            multipleValueLayout={multipleValueLayout}
                        />
                    ))}
                </FundFactsList>

                <Disclaimers
                    disclaimers={cardDisclaimers}
                    theme={{
                        ...theme,
                        DisclaimersList:
                            theme.FundFactsFootnotedDisclaimersList,
                        DisclaimerListItem:
                            theme.FundFactsFootnotedDisclaimerListItem,
                        DisclaimerCharacter:
                            theme.FundFactsFootnotedDisclaimerCharacter,
                        DisclaimerContent:
                            theme.FundFactsFootnotedDisclaimerContent,
                    }}
                />

                <Disclaimers
                    disclaimers={disclaimers}
                    theme={{
                        ...theme,
                        DisclaimersList: theme.FundFactsDisclaimersList,
                        DisclaimerListItem: theme.FundFactsDisclaimerListItem,
                        DisclaimerCharacter: theme.FundFactsDisclaimerCharacter,
                        DisclaimerContent: theme.FundFactsDisclaimerContent,
                    }}
                />
            </FundFactsWrapper>
        );
    }
}

export default withTheme(FundFacts) as any;



// WEBPACK FOOTER //
// ./src/Components/FundFacts.tsx